export default __webpack_public_path__ + "static/media/ongoing.9922984e.jpg";